import React from "react";

export default function BillProviderCardSkeleton({ viewMode = "grid" }) {
  return (
    <article
      className={`bills-page__provider-card bills-page__provider-card--skeleton card h-100 is-${viewMode} is-loading`}
      aria-hidden="true"
    >
      <div className="bills-page__provider-main">
        <div className="bills-page__provider-brand d-flex gap-3">
          <div className="bills-page__provider-logo skeleton-block" />
          <div className="bills-page__provider-copy">
            <div className="skeleton-line skeleton-line--title" />
            <div className="skeleton-line skeleton-line--description" />
            <div className="skeleton-line skeleton-line--short" />
          </div>
        </div>

        <div className="bills-page__provider-actions">
          <div className="bills-page__provider-buttons">
            <div className="skeleton-button bills-page__provider-button is-half" />
            <div className="skeleton-button bills-page__provider-button is-half" />
            <div className="skeleton-button bills-page__provider-button is-full" />
          </div>
          <div className="skeleton-button skeleton-button--wide bills-page__history-button" />
        </div>
      </div>
    </article>
  );
}
